export const getProductStatusLabel = (
  showSponsoredLabel: boolean,
  inventoryCount?: number
) => {
  const almostGone = inventoryCount && inventoryCount < 4;

  if (showSponsoredLabel && almostGone) {
    return `Sponsored, only ${inventoryCount} left`;
  }

  if (showSponsoredLabel) {
    return 'Sponsored';
  }

  if (almostGone) {
    return `Only ${inventoryCount} left`;
  }

  return null;
};
